import React from 'react';
import { motion } from 'framer-motion';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Vafrakökustefna</h1>
          
          <div className="bg-white rounded-2xl p-8 shadow-sm prose max-w-none">
            <h2>1. Hvað eru vafrakökur?</h2>
            <p>Vafrakökur (e. cookies) eru litlar textaskrár sem eru vistaðar á tæki þínu (tölvu, snjallsíma eða spjaldtölvu) þegar þú heimsækir vefsíðu. Þær eru notaðar til að bæta upplifun þína á vefsíðunni, muna stillingar þínar og safna tölfræðiupplýsingum um notkun vefsíðunnar.</p>

            <h2>2. Hvernig notum við vafrakökur?</h2>
            <p>Við notum vafrakökur í eftirfarandi tilgangi:</p>

            <h3>Nauðsynlegar vafrakökur</h3>
            <p>Þessar vafrakökur eru nauðsynlegar fyrir grunnvirkni vefsíðunnar og er ekki hægt að slökkva á þeim. Þær eru notaðar til að:</p>
            <ul>
              <li>Muna val þitt og stillingar</li>
              <li>Auðkenna þig sem notanda</li>
              <li>Tryggja öryggi vefsíðunnar</li>
            </ul>

            <h3>Greiningarvafrakökur</h3>
            <p>Við notum Google Analytics til að safna nafnlausum upplýsingum um notkun vefsíðunnar, þar á meðal:</p>
            <ul>
              <li>Hvernig þú komst á síðuna</li>
              <li>Hvaða síður þú skoðar</li>
              <li>Hversu lengi þú dvelur á síðunni</li>
              <li>Hvaða tæki þú notar</li>
            </ul>

            <h3>Markaðssetningarvafrakökur</h3>
            <p>Þessar vafrakökur eru notaðar til að:</p>
            <ul>
              <li>Sýna viðeigandi auglýsingar</li>
              <li>Mæla árangur auglýsinga</li>
              <li>Skilja hegðun notenda</li>
            </ul>

            <h2>3. Hvernig get ég stjórnað vafrakökum?</h2>
            <p>Þú getur stjórnað notkun vafrakaka í stillingum vafrans þíns. Þú getur:</p>
            <ul>
              <li>Séð hvaða vafrakökur eru vistaðar á tækinu þínu</li>
              <li>Eytt öllum eða völdum vafrakökum</li>
              <li>Lokað fyrir vafrakökur frá ákveðnum vefsíðum</li>
              <li>Stillt vafrann þinn til að hafna öllum vafrakökum</li>
            </ul>

            <p>Athugaðu að ef þú slekkur á vafrakökum gæti það haft áhrif á virkni vefsíðunnar og notendaupplifun þína.</p>

            <h2>4. Tegundir vafrakaka sem við notum</h2>
            <p>Hér er yfirlit yfir helstu vafrakökur sem við notum:</p>

            <table className="w-full mt-4">
              <thead>
                <tr>
                  <th className="text-left">Nafn</th>
                  <th className="text-left">Tilgangur</th>
                  <th className="text-left">Gildistími</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>session_id</td>
                  <td>Auðkenning notanda</td>
                  <td>Loka vafra</td>
                </tr>
                <tr>
                  <td>_ga</td>
                  <td>Google Analytics</td>
                  <td>2 ár</td>
                </tr>
                <tr>
                  <td>_gid</td>
                  <td>Google Analytics</td>
                  <td>24 klst</td>
                </tr>
                <tr>
                  <td>cookie_consent</td>
                  <td>Samþykki fyrir vafrakökum</td>
                  <td>1 ár</td>
                </tr>
              </tbody>
            </table>

            <h2>5. Þriðja aðila vafrakökur</h2>
            <p>Sumar vafrakökur koma frá þriðja aðila þjónustum sem við notum, svo sem:</p>
            <ul>
              <li>Google Analytics (greining)</li>
              <li>Facebook Pixel (markaðssetning)</li>
              <li>HotJar (notendagreining)</li>
            </ul>

            <h2>6. Breytingar á vafrakökustefnu</h2>
            <p>Við áskiljum okkur rétt til að uppfæra þessa stefnu. Allar breytingar verða birtar á þessari síðu og taka gildi við birtingu.</p>

            <h2>7. Samskipti</h2>
            <p>Ef þú hefur spurningar varðandi notkun okkar á vafrakökum, vinsamlegast hafðu samband:</p>
            <ul>
              <li>Netfang: hallo@vefsida.is</li>
              <li>Sími: (+354) 537-7990</li>
            </ul>

            <p className="text-sm text-gray-500 mt-8">Síðast uppfært: 11. mars 2024</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Cookies;